<template>
<div>
  <dd-text-box
      v-bind="computedProps"
      v-model="innerValue"
      v-on="computedListeners">
      <template v-slot:append>
      <v-btn icon color="primary" dark elevation="0" small v-if="readonly == false">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                color="primary"
                v-bind="attrs"
                @click="onDialogButtonClick"
                v-on="on"
                tabindex="-1"
                dark
                elevation="0"
                small>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
          </template>
          <span>発注検索用ポップアップを表示します</span>
        </v-tooltip>
      </v-btn>
    </template>
  </dd-text-box>
  <dd-hacchu-kensaku-dialog
    :showDialog="showDialog"
    @close="onDialogClosed"/>
</div>
</template>
<script>
import DdTextBox from '@/components/DdTextBox'
import DdHacchuKensakuDialog from '@/components/DdHacchuKensakuDialog'

export default {
  name: 'DdHacchuKensakuTextBox',
  extends: DdTextBox,
  components: {
    DdTextBox,
    DdHacchuKensakuDialog
  },
  props: () => ({
    /**
     * readonly
     */
    readonly: Boolean
  }),
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
        // readonly: this.readonly
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHelpDisplay () {
      return this.readonly === false
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.hacchuNo

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
    }
  }
}
</script>
<style scoped>
</style>
